<style lang="less" scoped>
.field-validation-error {
    .icon.icon-attention {
        color: inherit;
    }
}
</style>
<template>
    <div v-if="forceNonLocal || data.definition.settings.showErrorsLocally" v-show="!valid">
        <span class="field-validation-error" v-for="error in errors || []"><i class="icon icon-attention align-middle mr-1" title="Error" aria-label="Error: " role="img" />{{ error }}<i class="sr-only">,</i></span>
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useObservable } from "@vueuse/rxjs";
//import { BaseControlDefBase } from "../elements/BaseElementDef";
interface Props {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any; // TODO
    forceNonLocal?: boolean;
}
export default defineComponent({
    props: ["data", "forceNonLocal"],
    // @ts-ignore
    setup(props: Props) {
        const errors = useObservable(props.data.errors$());
        const valid = useObservable(props.data.valid$());

        return {
            errors,
            valid,
        };
    },
});
</script>
